export type StatementBank = {
  value: string;
  label: string;
  disabled?: boolean;
};

const OPEN_BANKS = new Set(['kcb', 'equity', 'ncba']);

const BANKS: { value: string; label: string }[] = [
  { value: 'kcb', label: 'KCB' },
  { value: 'equity', label: 'Equity Bank' },
  { value: 'ncba', label: 'NCBA' },
  { value: 'cooperative', label: 'Co-operative Bank' },
  { value: 'absa', label: 'Absa Bank' },
  { value: 'stanbic', label: 'Stanbic Bank' },
  { value: 'standard_chartered', label: 'Standard Chartered' },
  { value: 'dtb', label: 'Diamond Trust Bank' },
  { value: 'im_bank', label: 'I&M Bank' },
  { value: 'family', label: 'Family Bank' },
];

export const STATEMENT_BANKS: StatementBank[] = BANKS.map(bank => ({
  ...bank,
  disabled: !OPEN_BANKS.has(bank.value),
}));

export const QUICK_STATEMENT_BANKS = STATEMENT_BANKS.filter(bank => !bank.disabled);

export function statementBankLabel(bankId: string): string {
  return STATEMENT_BANKS.find(bank => bank.value === bankId && !bank.disabled)?.label ?? '';
}
